import { render } from "./workpermitview.vue?vue&type=template&id=d917a006&scoped=true"
import script from "./workpermitview.vue?vue&type=script&lang=js"
export * from "./workpermitview.vue?vue&type=script&lang=js"

import "./workpermitview.vue?vue&type=style&index=0&id=d917a006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d917a006"]])

export default __exports__